module.exports = __webpack_public_path__ + "static/media/marker_icon_tidepool.07395c49.svg";